exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-width[data-v-07d624dc] {\n  width: 315px;\n}", ""]);

// exports
